<div class="page">
  <div class="page__content">
    <h1 class="header">{{ "step_is_client.title" | translate }}</h1>
    <p>{{ "step_is_client.text" | translate }}</p>
    <form class="form" (keydown.enter)="$event.preventDefault()">
      <div class="option-selector">
        <custom-option [formControl]="isClientControl" [value]="true">
          <div option__label>
            {{ "step_is_client.option_client" | translate }}
          </div>
        </custom-option>

        <custom-option [formControl]="isClientControl" [value]="false">
          <div option__label>
            {{ "step_is_client.option_no_client" | translate }}
          </div>
        </custom-option>
      </div>

      <custom-form-field
        *ngIf="isClientControl.valueChanges | async"
        type="number"
        class="client-code__field"
        [label]="'step_is_client.field_client_code_label' | translate"
        [controlName]="'clientCode'"
        [formGroup]="clientCodeForm"
        [hint]="'step_is_client.field_client_code_hint' | translate"
      >
      </custom-form-field>
    </form>
  </div>
  <div class="page__footer">
    <button
      customButton
      customOnboardingNext
      [disabled]="
        isClientControl.invalid ||
        (isClientControl.value && clientCodeForm.invalid)
      "
      expand="full"
      size="large"
    >
      {{ "step_is_client.button_next" | translate }}
    </button>
  </div>
</div>
